<template>
  <div style="padding:50px; margin:0 auto; text-align: center;">
    <h1>
      404
    </h1>
  </div>
</template>

<script>
export default {
  name: 'CoreCommon404'
};
</script>
